import { useState } from "react";
import CustomSelect from "../../../Components/CustomSelect/CustomSelect";
import WYSIWYGContent from "../../../Components/WYSIWYGContent";

export const FirmwareVersionsComponent = ({
  title,
  description,
  label,
  buttonLabel,
  firmwareVersions,
}) => {
  const [selectedFirmware, setSelectedFirmware] = useState(0);
  const optionsFirmware = firmwareVersions.map((version) => ({
    value: version.version_file.url,
    label: (
      <span className="text-lg font-semibold">{version.version_name}</span>
    ),
  }));

  const submitFirmware = async (index) => {
    const url = optionsFirmware[index]?.value;
    if (!url) return;

    // Create a temporary hidden link element
    const link = document.createElement("a");
    link.href = url;

    // Extract the filename from the URL (e.g., "file.css")
    const filename = url.substring(url.lastIndexOf("/") + 1);
    link.setAttribute("download", filename);

    // Append to body, click it, and remove it
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div>
      {title && (
        <h1 className="text-jay-blue text-4xl normal-case font-primary font-bold mb-8">
          {title}
        </h1>
      )}
      {description && <p className="text-base mb-8">{description}</p>}

      <div className="p-12 bg-[#D9D9D9] w-full mb-14 text-center">
        <label className="text-sm text-black font-semibold mb-1 inline-block">
          {label}
        </label>
        <CustomSelect
          options={optionsFirmware}
          className="[&>button]:bg-white mb-8 mx-auto"
          onChange={setSelectedFirmware}
        />

        <button
          onClick={() => submitFirmware(selectedFirmware)}
          className="text-lg bg-error text-white min-h-14 px-6 py-2 min-w-48"
        >
          {buttonLabel}
        </button>
      </div>

      {firmwareVersions[selectedFirmware]?.release_notes && (
        <div>
          <h3 className="text-4xl mt-0 mb-9">Release Notes</h3>
          <WYSIWYGContent
            content={firmwareVersions[selectedFirmware].release_notes}
          />
        </div>
      )}
    </div>
  );
};
